import { noop } from 'js/utils/methods.util';
import { map, partition, pipe, propEq } from 'ramda';
import { launchGame as launchGameAction } from 'js/components/common/Game/actions';

import { BUTTON_TYPE } from './constants';
import { getButtonSpecificAction } from './buttonSpecificActions';

import style from '../../AdvancedPlayerMessage.scss';

export const getActionHandler = (
    {
        buttonId,
        buttonType,
        runHTCMDs,
        submitAdvancedDialog,
        showNotification,
        onClose = noop,
        ...rest
    }
) => {
    const { actionHandler, failureReason } = getButtonSpecificAction({ ...rest, showNotification });

    const getSubmitDialogData = failReason => ({
        buttonId,
        ...failReason
            ? {
                failedHTCMDs: [
                    {
                        htcmd: runHTCMDs && runHTCMDs[0],
                        failureReason: failReason
                    }
                ]
            }
            : {}
    });

    const submitCatcher = buttonType === BUTTON_TYPE.ACTIONABLE && !actionHandler
        ? () => showNotification('playtech.mobile.system.toast.actionFailed', { variant: 'error' }) // "submit" is an actual action - should show notification if failed
        : () => {}; // "submit" is just a tracker

    return () => {
        Promise.resolve(failureReason)
            .then(getSubmitDialogData)
            .then(submitAdvancedDialog)
            .catch(submitCatcher);
        Promise.resolve(actionHandler && actionHandler()).finally(onClose);
    };
};

export const prepareButtons = props =>
    map(({ buttonId, buttonType, buttonText, ...rest }) => {
            const onClick = getActionHandler({ buttonId, buttonType, ...rest, ...props });

            return {
                id: buttonId,
                text: buttonText,
                onClick,
                className: style.btn,
                size: 'large',
                view: 'primary',
                color: buttonType !== BUTTON_TYPE.CANCEL
                    ? 'success'
                    : 'negative',
                buttonType
            };
        }
    );

export const launchGame = game => launchGameAction({ code: game, container: 'player-message' });

export const getButtons = ({
    data,
    onClose,
    submitAdvancedDialog,
    showNotification,
    games,
    urlTypeList,
    getURLs
}) => {
    const { buttons } = data.action;
    const [[closeButtonConfig = {}], buttonsConfig] = pipe(
        prepareButtons({
            submitAdvancedDialog,
            onClose,
            showNotification,
            launchGame,
            games,
            urlTypeList,
            getURLs
        }),
        partition(propEq('buttonType', 'close'))
    )(buttons);
    const closePopupHandler = closeButtonConfig.onClick || onClose;

    return {
        buttons: buttonsConfig,
        onClose: closePopupHandler
    };
};
